import { FormikProps, getIn } from 'formik'
import React, { FC } from 'react'
import { Label, TimeInput } from '..' // assuming Label is your label component
import { FontSize } from '../../../_metronic/helpers'
import { useT } from '_metronic/i18n/Metronici18n'

interface IFormTimeInput {
  label?: string
  name: string
  placeholder?: string
  formik: FormikProps<any>
  isDisabled?: boolean
  isRequired?: boolean
  className?: string
  min?: string
  max?: string
  infoText?: string
  labelSize?: FontSize
  highlight?: boolean
  entity?: string
}

export const FormTimeInput: FC<IFormTimeInput> = ({
  label,
  name,
  placeholder,
  formik,
  isDisabled = false,
  className = '',
  isRequired = false,
  min = '',
  max = '',
  labelSize,
  infoText,
  highlight,
  entity,
}) => {
  const { t } = useT()
  const errorMessage = getIn(formik.errors, name, null)
  const touched = getIn(formik.touched, name, false)
  const value = getIn(formik.values, name, '')

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.setFieldValue(name, e.target.value)
  }

  const resolvedLabel = label ?? (entity ? t(`${entity}.label`) : undefined)

  return (
    <div className={`${className}`}>
      {resolvedLabel && (
        <Label
          className='mb-2'
          isRequired={isRequired}
          size={labelSize}
          infoText={infoText}
          highlight={highlight}
        >
          {resolvedLabel}
        </Label>
      )}
      <TimeInput
        {...formik.getFieldProps(name)}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        disabled={formik.isSubmitting || isDisabled}
        className={touched && errorMessage ? 'is-invalid' : touched ? 'is-valid' : ''}
        isInvalid={touched && !!errorMessage}
        isValid={touched && !errorMessage}
        min={min}
        max={max}
      />
      {touched && errorMessage && (
        <div className='invalid-feedback d-block'>
          <span role='alert'>{errorMessage}</span>
        </div>
      )}
    </div>
  )
}
